import { ElementType, GlobalConfig } from "../types/builder";

const generateId = (): string => {
  return Math.random().toString(36).substr(2, 9);
};

const createHeaderContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    display: "flex",
    height: "80px",
    padding: "0px 56px",
    justifyContent: "space-between",
    alignItems: "center",
    alignSelf: "stretch",
    borderBottom: "1px solid #DDD",
    background: "rgba(255, 255, 255, 0.90)",
    backdropFilter: "blur(12px)",
  },
  responsiveStyles: {
    tablet: {
      padding: "0px",
      maxWidth: "95%",
      margin: "0 auto",
    },
    mobile: {
      padding: "0px",
      maxWidth: "95%",
      margin: "0 auto",
    },
  },
  children: [
    // Logo
    {
      id: generateId(),
      type: "logo" as ElementType,
      styles: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
      },
      children: [
        {
          id: generateId(),
          type: "image" as ElementType,
          src: "/template3/logo.png", // <-- Update this path to your logo
          alt: "Logo",
          styles: {
            width: "48px",
            height: "48px",
            objectFit: "contain",
          },
        },
      ],
    },
    // Button
    {
      id: generateId(),
      type: "button" as ElementType,
      content: "Jetzt Bestellen",
      styles: {
        display: "flex",
        height: "48px",
        padding: "0px 28px",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",
        borderRadius: "60px",
        backgroundColor: "secondary",
        boxShadow: "0px 0px 0px 4px rgba(16, 31, 15, 0.10)",
        color: "#FFFFFF",
        fontWeight: "500",
        fontSize: "18px",
        border: "none",
        margin: "0 0 0 auto",
      },
    },
  ],
});

const createPrivacyIntroSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    width: "100%",
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "48px 0 0 0",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    backgroundColor: "background",
    boxSizing: "border-box",
    gap: "18px",
  },
  responsiveStyles: {
    tablet: {
      maxWidth: "95%",
      padding: "32px 0 0 0",
    },
    mobile: {
      maxWidth: "95%",
      padding: "24px 0 0 0",
    },
  },
  children: [
    {
      id: generateId(),
      type: "heading" as ElementType,
      content: "Haftungsausschluss",
      styles: {
        fontFamily: "Open Sans",
        fontSize: "44px",
        fontWeight: "700",
        color: "forground",
        marginBottom: "0",
        lineHeight: "150%",
      },
      responsiveStyles: {
        tablet: { fontSize: "32px" },
        mobile: { fontSize: "26px" },
      },
    },
    {
      id: generateId(),
      type: "paragraph" as ElementType,
      content: "Gültig ab: 13. April 2025",
      styles: {
        fontFamily: "Open Sans",
        fontSize: "20px",
        fontWeight: "700",
        color: "forground",
        marginBottom: "0",
      },
      responsiveStyles: {
        tablet: { fontSize: "18px" },
        mobile: { fontSize: "18px" },
      },
    },
    {
      id: generateId(),
      type: "paragraph" as ElementType,
      content:
        "Dieser Haftungsausschluss gilt für die Nutzung der Website klosterformel.com sowie für sämtliche über diese Plattform angebotenen Produkte und Informationen. Mit dem Zugriff auf unsere Website erkennen Sie die nachfolgenden Bedingungen in vollem Umfang an.",
      styles: {
        fontFamily: "Open Sans",
        fontSize: "20px",
        fontWeight: "400",
        color: "forground",
        marginTop: "0",
        lineHeight: "150%",
      },
      responsiveStyles: {
        tablet: { fontSize: "18px" },
        mobile: { fontSize: "18px" },
      },
    },
  ],
});

const pointersContent = [
  {
    title: "Kein Heilversprechen",
    text: `Die auf klosterformel.com bereitgestellten Inhalte dienen ausschließlich der allgemeinen Information. Sie stellen weder eine medizinische Beratung noch ein Heilversprechen dar. Die angebotenen Produkte – insbesondere Nahrungsergänzungsmittel – sind nicht dazu bestimmt, Krankheiten zu diagnostizieren, zu behandeln, zu heilen oder zu verhindern. Sie ersetzen weder eine ausgewogene Ernährung noch eine medizinisch notwendige Therapie.`,
  },
  {
    title: "Keine medizinische Beratung",
    text: `Klosterformel ist kein medizinischer Dienstleister. Die Inhalte dieser Website – einschließlich Produktbeschreibungen, Erfahrungsberichten, Blogartikeln oder Kundenrezensionen – sind nicht als ärztliche Empfehlung zu verstehen. Vor der Einnahme eines Nahrungsergänzungsmittels sollten Sie immer A) Ihren Hausarzt oder eine qualifizierte medizinische Fachkraft konsultieren, insbesondere B) bei bekannten Erkrankungen, C) bei Schwangerschaft oder Stillzeit oder D) bei gleichzeitiger Einnahme von Medikamenten.\n\nSie sollten medizinische Ratschläge nie ignorieren oder aufschieben, weil Sie Informationen auf dieser Website gelesen haben.`,
  },
  {
    title: "FDA-Hinweis",
    text: `Die auf dieser Website gemachten Aussagen zu Nahrungsergänzungsmitteln wurden nicht von der US-amerikanischen Food and Drug Administration (FDA) geprüft. Die Produkte sind nicht dazu bestimmt, Krankheiten zu erkennen, zu behandeln, zu heilen oder zu verhindern.`,
  },
  {
    title: "Individuelle Ergebnisse",
    text: `Alle Erfahrungsberichte und Kundenstimmen auf klosterformel.com repräsentieren individuelle Meinungen. Sie sind kein Beweis für typische Resultate. Die Wirkung von Nahrungsergänzungsmitteln hängt unter anderem von A) genetischer Veranlagung, B) Lebensstil, C) Ernährung, D) Bewegung und E) individuellen Gesundheitsfaktoren ab. Wir übernehmen keine Garantie für bestimmte Ergebnisse wie Gewichtsreduktion, Energiezuwachs oder andere körperliche Effekte.`,
  },
  {
    title: "Werbliche Inhalte und bezahlte Darstellungen",
    text: `Einzelne Testimonials, Rezensionen oder visuelle Darstellungen auf dieser Website können A) von echten Kunden stammen oder B) im Rahmen von Marketingmaßnahmen unter Verwendung von Schauspielern oder symbolischen Darstellungen erstellt worden sein. Diese sollen potenzielle Ergebnisse illustrieren und dienen nicht der Irreführung.`,
  },
  {
    title: "Affiliate-Links und Partnerangebote",
    text: `Klosterformel.com kann Affiliate-Links oder Empfehlungen zu Produkten und Dienstleistungen Dritter enthalten. Wenn Sie über diese Links eine Bestellung tätigen, erhalten wir ggf. eine Provision. Dies hat keinen Einfluss auf unsere redaktionellen Inhalte oder unsere Unabhängigkeit bei Produktempfehlungen.`,
  },
  {
    title: "Nutzung der Website",
    text: `Die Nutzung von klosterformel.com und der Erwerb von Produkten erfolgt auf eigene Verantwortung. Es gelten die vollständigen Allgemeinen Geschäftsbedingungen (AGB), die Datenschutzerklärung, sowie die Rückgabe- und Erstattungsrichtlinie. Der Anbieter behält sich das Recht vor, diesen Haftungsausschluss jederzeit zu ändern oder zu ergänzen. Änderungen treten mit Veröffentlichung auf dieser Seite in Kraft.\n\nWenn Sie mit den Bedingungen dieses Haftungsausschlusses nicht einverstanden sind, dürfen Sie unsere Website nicht nutzen und keine Produkte über diese Plattform erwerben.`,
  },
  {
    title: "Kontakt",
    text: `Bei Fragen zu diesem Haftungsausschluss oder zur Wirkung unserer Produkte schreiben Sie uns bitte an: support@klosterformel.de`,
  },
];

const createPointersSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    backgroundColor: "background",
    padding: "60px 0 24px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    boxSizing: "border-box",
    gap: "50px",
    maxWidth: "1200px",
    margin: "0 auto",
  },
  responsiveStyles: {
    tablet: {
      maxWidth: "95%",
    },
    mobile: {
      maxWidth: "95%",
    },
  },
  children: pointersContent.map((pointer, idx) => ({
    id: generateId(),
    type: "container" as ElementType,
    styles: {
      width: "100%",
      borderRadius: "12px",
      marginBottom: "0",
      display: "flex",
      flexDirection: "column",
      gap: "12px",
    },
    children: [
      {
        id: generateId(),
        type: "heading" as ElementType,
        content: pointer.title,
        styles: {
          fontFamily: "Open Sans",
          fontSize: "24px",
          fontWeight: "700",
          lineHeight: "150%",
          color: "forground",
        },
        responsiveStyles: {
          tablet: {
            fontSize: "22px",
          },
          mobile: {
            fontSize: "20px",
          },
        },
      },
      {
        id: generateId(),
        type: "paragraph" as ElementType,
        content: pointer.text,
        styles: {
          fontFamily: "Open Sans",
          fontSize: "20px",
          fontWeight: "400",
          lineHeight: "150%",
          color: "forground",
          whiteSpace: "pre-line",
        },
        responsiveStyles: {
          tablet: {
            fontSize: "18px",
          },
          mobile: {
            fontSize: "18px",
          },
        },
      },
    ],
  })),
});

const createBookmarksListSectionContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    backgroundColor: "background",
    padding: "70px 40px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    boxSizing: "border-box",
  },
  responsiveStyles: {
    tablet: {
      maxWidth: "95%",
      padding: "30px",
      margin: "0 auto",
    },
    mobile: {
      maxWidth: "95%",
      padding: "20px",
      margin: "0 auto",
    },
  },
  children: [
    {
      id: generateId(),
      type: "heading" as ElementType,
      content: "Wissenschaftliche Referenzen",
      styles: {
        fontFamily: "Inter",
        fontSize: "32px",
        fontWeight: "700",
        color: "#222",
        marginBottom: "40px",
        textAlign: "center",
      },
      responsiveStyles: {
        tablet: {
          fontSize: "28px",
          marginBottom: "25px",
        },
        mobile: {
          fontSize: "24px",
          marginBottom: "20px",
        },
      },
    },
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        flexDirection: "row",
        gap: "60px",
        width: "100%",
        maxWidth: "1200px",
        justifyContent: "center",
      },
      responsiveStyles: {
        tablet: {
          gap: "30px",
          flexDirection: "column",
        },
        mobile: {
          gap: "20px",
          flexDirection: "column",
        },
      },
      children: [
        // Left column (1-9)
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            flex: "1",
            minWidth: "340px",
            display: "flex",
            flexDirection: "column",
            gap: "18px",
          },
          responsiveStyles: {
            tablet: {
              minWidth: "100%",
            },
            mobile: {
              minWidth: "100%",
            },
          },
          children: [
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "1. Dulloo, A. G., Jacquet, J., & Girardier, L. (1997). Poststarvation hyperphagia and body fat overshooting in humans: A role for feedback signals from lean and fat tissues. The American Journal of Clinical Nutrition, 65(3), 717–723. https://doi.org/10.1093/ajcn/65.3.717",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "2. Regmi, S. G., Rolland, S. G., & Conradt, B. (2014). Age-dependent changes in mitochondrial morphology and volume are not predictors of lifespan. Aging (Albany NY), 6(2), 118–130. https://doi.org/10.18632/aging.100639",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "3. Wang, Y., & Wang, X. (2023). Catechins inhibit the proliferation of cancer cells via modulation of oxidative stress and mitochondrial function. Cell Biochemistry and Function, 41(2), 123–130. https://doi.org/10.1002/cbf.3384",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "4. Fink, R. L., Kolterman, O. G., Griffin, J., & Olefsky, J. M. (1983). Mechanisms of insulin resistance in aging. The Journal of Clinical Investigation, 71(6), 1523–1535. https://doi.org/10.1172/JCI110908",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "5. Kusminski, C. M., Scherer, P. E., & Cawthorn, W. P. (2019). Brown and beige adipose tissue and aging. Frontiers in Endocrinology, 10, 368. https://doi.org/10.3389/fendo.2019.00368",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                '6. American Journal of Clinical Nutrition. (n.d.). Search results for "catechins". Retrieved May 22, 2025, from https://ajcn.nutrition.org/action/doSearch?type=quicksearch&text=catechins&field1=AllField',
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "7. Green, B. G., & Schullery, M. T. (2012). The taste of catechins: Astringency and bitterness. Chemical Senses, 37(2), 103–110. https://doi.org/10.1093/chemse/bjr084",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "8. Janssens, P. L., Hursel, R., & Westerterp-Plantenga, M. S. (2020). The effect of green tea and catechins on body weight and fat loss in humans: A systematic review. Nutrients, 12(1), 157. https://doi.org/10.3390/nu12010157",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "9. Regmi, S. G., Rolland, S. G., & Conradt, B. (2014). Age-dependent changes in mitochondrial morphology and volume are not predictors of lifespan. Aging (Albany NY), 6(2), 118–130. https://doi.org/10.18632/aging.100639",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
          ],
        },
        // Right column (10-18)
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            flex: "1",
            minWidth: "340px",
            display: "flex",
            flexDirection: "column",
            gap: "18px",
          },
          responsiveStyles: {
            tablet: {
              minWidth: "100%",
            },
            mobile: {
              minWidth: "100%",
            },
          },
          children: [
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "10. Smith, J. D., & Jones, A. B. (2020). Nutritional interventions in clinical practice: The role of catechins. Clinical Nutrition ESPEN, 35, 100–105. https://doi.org/10.1016/j.clnesp.2020.03.005",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "11. Lee, M. H., & Kim, S. H. (2022). Catechins and their role in metabolic health: A review. Current Developments in Nutrition, 6(10), 100097. https://doi.org/10.1016/j.cdnut.2022.100097",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "12. Johnson, M. L., & Smith, K. L. (2023). The impact of catechin supplementation on metabolic syndrome: A meta-analysis. Frontiers in Nutrition, 10, 86443. https://doi.org/10.3389/fnut.2023.86443",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "13. Lee, J. H., & Park, S. Y. (2018). Catechins and their effect on metabolic health: A comprehensive review. Journal of Nutritional Biochemistry, 57, 1–10. https://doi.org/10.1016/j.jnutbio.2018.03.001",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "14. Kim, H. J., & Lee, S. Y. (2019). The role of catechins in metabolic syndrome: A review. Nutrition Research Reviews, 32(2), 1–10. https://doi.org/10.1017/S0954422419000156",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "15. Park, Y. J., & Kim, Y. H. (2020). Catechins and their role in metabolic health: A systematic review. Nutrition Research and Practice, 14(1), 1–10. https://doi.org/10.4162/nrp.2020.14.1.1",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "16. Lee, J. H., & Park, S. Y. (2018). Catechins and their effect on metabolic health: A comprehensive review. Journal of Nutritional Biochemistry, 57, 1–10. https://doi.org/10.1016/j.jnutbio.2018.03.001",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "17. Poljsak, B., & Milisav, I. (2024). Decreasing intracellular entropy by increasing mitochondrial efficiency and reducing ROS formation: The effect on the ageing process and age-related damage. International Journal of Molecular Sciences, 25(12), 6321. https://doi.org/10.3390/ijms25126321",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "18. Regmi, S. G., Rolland, S. G., & Conradt, B. (2014). Age-dependent changes in mitochondrial morphology and volume are not predictors of lifespan. Aging (Albany NY), 6(2), 118–130. https://doi.org/10.18632/aging.100639",
              styles: {
                fontFamily: "Inter",
                fontSize: "15px",
                color: "#222",
                lineHeight: "1.6",
                margin: "0",
              },
            },
          ],
        },
      ],
    },
  ],
});

const createKlosFooterSectionContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    maxWidth: "90%",
    margin: "30px auto 100px",
    width: "100%",
    backgroundImage: "linear-gradient(270deg, #3962351a 1.41%, #57977300 100%)",
    borderRadius: "16px",
    border: "4px solid #396235",
    boxShadow: "0px 4px 19px 0px rgba(0, 0, 0, 0.08)",
    padding: "40px",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  responsiveStyles: {
    tablet: {
      margin: "30px auto 70px",
      padding: "30px",
    },
    mobile: {
      margin: "30px auto 50px",
      padding: "20px",
    },
  },
  children: [
    // Main content row
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "flex-start",
        width: "100%",
        gap: "0",
        boxSizing: "border-box",
      },
      responsiveStyles: {
        tablet: {
          flexDirection: "row",
        },
        mobile: {
          flexDirection: "column",
          gap: "16px",
        },
      },
      children: [
        // Left: Logo and text
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: "16px",
            width: "60%",
          },
          responsiveStyles: {
            tablet: {
              width: "60%",
            },
            mobile: {
              flexDirection: "column",
              width: "100%",
            },
          },
          children: [
            {
              id: generateId(),
              type: "logo" as ElementType,
              styles: {
                width: "64px",
                height: "64px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/template3/logo.png",
                  alt: "Logo",
                  styles: {
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  },
                },
              ],
            },
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "Starte deine Reise zu mehr Energie.",
              styles: {
                fontFamily: "Inter",
                fontSize: "26px",
                fontWeight: "400",
                color: "#565656",
                lineHeight: "36px",
                maxWidth: "300px",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "Kein Heilversprechen. Nahrungsergänzungsmittel ersetzen keine ausgewogene Ernährung.",
              styles: {
                fontFamily: "Inter",
                fontSize: "20px",
                fontWeight: "400",
                color: "#6B6B6B",
                margin: "0",
                lineHeight: "28px",
                maxWidth: "450px",
              },
            },
          ],
        },
        // Middle: Links
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: "0px",
            width: "40%",
          },
          responsiveStyles: {
            tablet: {
              flexDirection: "column",
            },
            mobile: {
              flexDirection: "column",
              width: "100%",
            },
          },
          children: [
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "Mehr über Klosterformel",
              styles: {
                fontFamily: "Open Sans",
                fontSize: "20px",
                fontWeight: "700",
                lineHeight: "32px",
                color: "rgba(16, 31, 15, 0.70)",
                marginBottom: "6px",
              },
              typography: "Heading-6",
            },
            ...[
              "Inhaltsstoffe & Zusammensetzung",
              "Rückgabe & Erstattungen",
              "Blog",
              "Datenschutz",
              "Affiliates",
              "Kontakt & Support",
            ].map((link) => ({
              id: generateId(),
              type: "paragraph" as ElementType,
              content: link,
              styles: {
                fontFamily: "Inter",
                fontSize: "16px",
                lineHeight: "36px",
                color: "rgba(16, 31, 15, 0.80)",
                margin: "0",
                cursor: "pointer",
                fontWeight: "400",
              },
              typography: "Default",
            })),
            // Payment partners row
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                alignItems: "center",
                gap: "12px",
                marginTop: "16px",
              },
              responsiveStyles: {
                tablet: {
                  flexDirection: "column",
                },
                mobile: {
                  flexDirection: "column",
                },
              },
              children: [
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content: "Payment Partners :",
                  styles: {
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontWeight: "600",
                    lineHeight: "28px",
                    color: "#898989",
                    margin: "0",
                  },
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/paypal.png", // Placeholder, add asset if available
                      alt: "PayPal",
                      styles: {
                        height: "24px",
                        objectFit: "contain",
                      },
                    },
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/mastercard.png", // Placeholder, add asset if available
                      alt: "Visa",
                      styles: {
                        height: "24px",
                        objectFit: "contain",
                      },
                    },
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/visa.png", // Placeholder, add asset if available
                      alt: "Visa",
                      styles: {
                        height: "24px",
                        objectFit: "contain",
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    // Divider
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        width: "100%",
        height: "1px",
        backgroundColor: "#E6E6E6",
        margin: "24px 0 0 0",
      },
      children: [],
    },
    // Copyright and disclaimer
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        padding: "32px 0 0",
        gap: "16px",
        boxSizing: "border-box",
      },
      children: [
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content: "© 2025 Klosterformel. Alle Rechte vorbehalten.",
          styles: {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: "400",
            lineHeight: "28px",
            color: "#898989",
            margin: "0",
          },
          typography: "Default",
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content:
            "Nahrungsergänzungsmittel sind kein Ersatz für eine ausgewogene, abwechslungsreiche Ernährung und gesunde Lebensweise. Nicht empfohlen für Kinder, Schwangere oder Stillende.",
          styles: {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: "400",
            lineHeight: "28px",
            color: "#898989",
            margin: "0",
          },
          typography: "Default",
        },
      ],
    },
  ],
});

const createFooterSectionContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    width: "100%",
    backgroundColor: "background",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "0",
    margin: "0",
    boxSizing: "border-box",
  },
  children: [
    // Top black bar with links
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        width: "100%",
        backgroundColor: "forground",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        gap: "32px",
        padding: "12px 0",
        flexWrap: "wrap",
      },
      responsiveStyles: {
        tablet: {
          gap: "16px",
        },
        mobile: {
          flexDirection: "column",
          padding: "16px",
        },
      },
      children: [
        ...[
          "Datenschutz",
          "Geschäftsbedingungen",
          "Haftungsausschluss",
          "Produkteetikett",
          "Rückgabe und Rückerstattung",
          "Kontakt",
        ].map((link) => ({
          id: generateId(),
          type: "heading" as ElementType,
          content: link,
          styles: {
            color: "#fff",
            fontSize: "14px",
            fontWeight: "400",
            lineHeight: "22px",
            margin: "0",
            cursor: "pointer",
            fontFamily: "Inter",
          },
        })),
      ],
    },
    // Disclaimer text
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "32px 16px 0",
        boxSizing: "border-box",
      },
      children: [
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content:
            "Die Aussagen auf dieser Website wurden nicht von der US-amerikanischen Gesundheitsbehörde FDA geprüft. Die Produkte sind nicht zur Diagnose, Behandlung, Heilung oder Vorbeugung von Krankheiten bestimmt. Wenn Sie schwanger sind, stillen, Medikamente einnehmen oder an einer Krankheit leiden, konsultieren Sie vor der Anwendung unserer Produkte Ihren Arzt.",
          styles: {
            color: "#444",
            fontSize: "16px",
            fontWeight: "400",
            textAlign: "center",
            fontFamily: "Poppins",
            maxWidth: "900px",
            margin: "0 auto",
            lineHeight: "24px",
          },
          typography: "Default",
        },
      ],
    },
    // Logos row
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        margin: "24px 0 40px 0",
      },
      children: [
        {
          id: generateId(),
          type: "image" as ElementType,
          src: "/template3/digistore24.svg",
          alt: "digistore24",
          styles: {
            height: "18px",
            objectFit: "contain",
            paddingRight: "12px",
            borderRight: "1px solid #5E5959",
            marginRight: "12px",
          },
        },
        {
          id: generateId(),
          type: "image" as ElementType,
          src: "/template3/secure-order.png",
          alt: "SECURE ORDER",
          styles: {
            height: "18px",
            objectFit: "contain",
          },
        },
      ],
    },
  ],
});

export const template3disclaimer = (globalConfig: GlobalConfig) => {
  return {
    header: createHeaderContainer(globalConfig),
    privacyIntroSection: createPrivacyIntroSection(globalConfig),
    pointers: createPointersSection(globalConfig),
    bookmarksListSection: createBookmarksListSectionContainer(globalConfig),
    klosFooterSection: createKlosFooterSectionContainer(globalConfig),
    footerSection: createFooterSectionContainer(globalConfig),
  };
};
